module.exports = __webpack_public_path__ + "static/media/login-bg.79fea343.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-bg.jpg
// module id = 975
// module chunks = 7